module.exports = __webpack_public_path__ + "static/media/home_phone3.3c3acc6f.png";